import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Sidebar.css";
import churchImg from "../assets/church-profile.jpg";
import giveNetImg from "../assets/give-net.png";
import { firestore, doc, getDoc } from "../firebase-config";

const Sidebar = () => {
  const [featuredPosts, setFeaturedPosts] = useState([]);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        // Get featured post IDs
        const settingsSnap = await getDoc(doc(firestore, 'siteSettings', 'featured'));
        if (!settingsSnap.exists()) return;
        const ids = settingsSnap.data().featuredPosts || [];
        if (!ids.length) return;

        // Fetch each post's title
        const posts = await Promise.all(
          ids.map(async (id) => {
            const postSnap = await getDoc(doc(firestore, 'posts', id));
            if (!postSnap.exists()) return null;
            const data = postSnap.data();
            return { id, title: data.title, category: data.category };
          })
        );
        setFeaturedPosts(posts.filter(Boolean));
      } catch (err) {
        console.error('Error fetching featured posts:', err);
      }
    };
    fetchFeatured();
  }, []);

  return (
    <aside className="sidebar">
      <h3>The Bible Says</h3>
      <p id="bible-quote">
        "For we preach not ourselves, but Christ Jesus the Lord; and ourselves your servants for Jesus sake.
        For God, who commanded the light to shine out of darkness, hath shined in our hearts, to give the
        light of the knowledge of the glory of God in the face of Jesus Christ"
      </p>
      <p id="bible-quote-reference">2 Corinthians 4:5-6</p>
      <hr />

      <h3>We Are Here</h3>
      <p>
        Crich Baptist Church<br />Market Place<br />Crich, Derbyshire<br />DE4 5DD
      </p>
      <img src={churchImg} alt="Crich Baptist Church" className="church-img" />

      {/* Featured Posts */}
      {featuredPosts.length > 0 && (
        <div className="sidebar-section">
          <h3>Featured Posts</h3>
          <ul className="featured-posts-list">
            {featuredPosts.map(post => (
              <li key={post.id}>
                <Link to={`/blog/${post.id}`}>
                  {post.title}
                </Link>
                {post.category && (
                  <span className="featured-post-category">{post.category}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Support Section */}
      <div className="sidebar-section">
        <h3>Support</h3>
        <a href="https://www.stewardship.org.uk/partners/20277964" target="_blank" rel="noopener noreferrer">
          <img src={giveNetImg} alt="Support Us - Give.net" className="donation-img" />
        </a>
      </div>
    </aside>
  );
};

export default Sidebar;